var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgitimKurumlari(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#4775B8",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.322 9.675l5.241-3.018c.373-.21.821-.21 1.194 0l5.92 3.405a.666.666 0 01.323.577v4.205c0 .36-.28.656-.622.656-.342 0-.622-.295-.622-.656v-3.877l-4.999 2.88c-.373.216-.82.216-1.194 0l-5.241-3.018c-.43-.249-.43-.905 0-1.154zM7 14.36V12.5l3.883 2.186c.386.219.848.219 1.234 0L16 12.5v1.861c0 .484-.257.935-.669 1.166l-3.214 1.809a1.243 1.243 0 01-1.234 0l-3.214-1.808A1.34 1.34 0 017 14.36z",
    fill: "#fff"
  })));
}
export default SvgEgitimKurumlari;